import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import {
  CalendarRoomRow,
  CalendarRoomRowApiModel,
  RoleType,
  calendarItemsConverter,
  environment,
} from '@bookly/shared';

@Injectable({
  providedIn: 'root',
})
export class RoomsCalendarApiService {
  readonly #http = inject(HttpClient);
  readonly #roomsCalendarUrl = environment.admin.roomsCalendarApi;

  public getRoomsEvents(
    roleType: RoleType,
    dateFrom: string,
    dateTo: string
  ): Observable<CalendarRoomRow[]> {
    return this.#http
      .get<CalendarRoomRowApiModel[]>(
        `${this.#roomsCalendarUrl}/${roleType}/calendar`,
        {
          params: { from: dateFrom, to: dateTo },
        }
      )
      .pipe(
        map(roomsCalendarEvents =>
          calendarItemsConverter(roomsCalendarEvents, dateFrom, dateTo)
        )
      );
  }
}
